<ng-container *ngIf="{
    boxed: layoutSvc.boxed$ | async,
    dir: layoutSvc.dir$ | async,
    expandLogo: layoutSvc.expandLogo$ | async,
    headerpos: layoutSvc.headerpos$ | async,
    isCollapsed: layoutSvc.isCollapsed$ | async,
    layout: layoutSvc.layout$ | async,
    logobg: layoutSvc.logobg$ | async,
    navbarbg: layoutSvc.navbarbg$ | async,
    showMobileMenu: layoutSvc.showMobileMenu$ | async,
    sidebarbg: layoutSvc.sidebarbg$ | async,
    sidebarpos: layoutSvc.sidebarpos$ | async,
    sidebartype: layoutSvc.sidebartype$ | async,
    theme: layoutSvc.theme$ | async
  } as options">
  <div id="main-wrapper" [ngClass]="{ 'show-sidebar': options.showMobileMenu }" [dir]="options.dir"
    [attr.data-theme]="options.theme" [attr.data-layout]="options.layout" [attr.data-sidebartype]="options.sidebartype"
    [attr.data-sidebar-position]="options.sidebarpos" [attr.data-header-position]="options.headerpos"
    [attr.data-boxed-layout]="options.boxed">
    <header class="topbar" [attr.data-navbarbg]="options.navbarbg">
      <nav class="d-flex top-navbar navbar-expand-md"
        [ngClass]="options.navbarbg === 'skin6' ? 'navbar-light' : 'navbar-dark'">
        <div class="navbar-header" [ngClass]="options.expandLogo ? 'expand-logo' : ''"
          [attr.data-logobg]="options.logobg">
          <a (click)="toggleMobileMenu()" class="nav-toggler waves-effect waves-light d-block d-md-none"
            href="javascript:void(0)">
            <i class="ti" [ngClass]="options.showMobileMenu ? 'ti-close' : 'ti-menu'"></i>
          </a>
          <a class="navbar-brand" routerLink="/">
            <span class="logo-icon waves-effect">
              <img src="assets/images/unity4-logo-icon.svg" alt="Unity4" class="dark-logo" />
              <img src="assets/images/unity4-logo-light-icon.svg" alt="Unity4" class="light-logo" />
            </span>
            <span class="logo-text waves-effect">
              <img src="assets/images/unity4-logo-text.svg" alt="homepage" class="dark-logo" />
              <img src="assets/images/unity4-logo-light-text.svg" class="light-logo" alt="homepage" />
            </span>
          </a>
          <a class="topbartoggler d-block d-md-none waves-effect waves-light" href="javascript:void(0)"
            (click)="toggleCollapsed()" [attr.aria-expanded]="!options.isCollapsed"
            data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent">
            <i class="ti ti-more"></i>
          </a>
        </div>
        <div class="navbar-collapse collapse" id="navbarSupportedContent" [attr.data-navbarbg]="options.navbarbg"
          [ngbCollapse]="!options.isCollapsed">
          <lib-navigation (toggleSidebar)="toggleSidebarType()" class="w-100">
            <ng-content select="[navigation]"></ng-content>
          </lib-navigation>
        </div>
      </nav>
    </header>
    <aside class="left-sidebar" [attr.data-sidebarbg]="options.sidebarbg" (mouseover)="expandLogo()"
      (mouseout)="expandLogo()">
      <div class="scroll-sidebar d-flex flex-column flex-grow-1">
        <lib-sidebar>
          <ng-content select="[sidebar]"></ng-content>
        </lib-sidebar>
      </div>
    </aside>
    <div class="page-wrapper">
      <lib-breadcrumb></lib-breadcrumb>
      <div class="container-fluid">
        <router-outlet></router-outlet>
      </div>
    </div>
    <lib-blade>
      <ng-content select="[blade]"></ng-content>
    </lib-blade>
    <!--<div class="chat-windows"></div>-->
  </div>
</ng-container>